import { render } from "./AssignProducts.vue?vue&type=template&id=e4003c3e&scoped=true&ts=true"
import script from "./AssignProducts.vue?vue&type=script&lang=ts"
export * from "./AssignProducts.vue?vue&type=script&lang=ts"

import "./AssignProducts.vue?vue&type=style&index=0&id=e4003c3e&scoped=true&lang=css"

import exportComponent from "D:\\YellowBeardProject\\Hermelin\\hermelinshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4003c3e"]])

export default __exports__